import { REGIONS } from 'shared/constants';

const defaultProps = require('./default-props');

const slots = [
  {
    slotId: 'menu-bar',
    label: 'Menu bar'
  },
  {
    slotId: 'top-section',
    label: 'Top Section'
  },
  {
    slotId: 'additional-content',
    label: 'Additional Content'
  },
  {
    slotId: 'footer',
    label: 'Footer area'
  }
];

const templateSettings = [
  {
    type: 'ENUM',
    key: 'region',
    label: 'Region',
    options: REGIONS
  },
  {
    type: 'STRING',
    key: 'title',
    label: 'Page Title'
  },
  {
    type: 'STRING',
    key: 'all_years_tag',
    label: 'All Years Tag'
  },
  {
    type: 'STRING',
    key: 'article_limit',
    label: 'Articles Per Page'
  }
];

export default {
  id: 'PressRoomLanding',
  name: 'Press Room Landing',
  creator: 'FF Web',
  updatedBy: 'Claire Lin',
  createdAt: 1507588526000,
  updatedAt: 1507588526000,
  slots,
  templateSettings,
  defaultProps
};

